import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { AdminServicesService } from '../../admin-services.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-view-contact-us-admin',
  templateUrl: './view-contact-us-admin.component.html',
  styleUrls: ['./view-contact-us-admin.component.css']
})
export class ViewContactUsAdminComponent implements OnInit {

  config: any;
  collection: any;
  term: string;
  p: number = 1;
  constructor(public admin: AdminServicesService,
    public toastr: ToastrService,
    private SpinnerService: NgxSpinnerService) {

    // //Create dummy data
    // for (var i = 0; i < this.collection.count; i++) {
    //   this.collection.data.push(
    //     {
    //       id: i + 1,
    //       value: "items number " + (i + 1)
    //     }
    //   );
    // }

    this.config = {
      itemsPerPage: 10,
      currentPage: 1,
      // totalItems: this.collection.id
    };
  }

  ngOnInit() {
    this.SpinnerService.show();
    this.admin.viewContactus().subscribe((res: any) => {
      this.SpinnerService.hide();
      if (res.code === 200) {
        this.collection = res.data;
      } else {
        console.log(res.message);
      }
    }, (err) => {
      console.log(err);
    });
  }
  pageChanged(event) {
    this.config.currentPage = event;
  }
  // temp = [];
  // rows = [];

  // @ViewChild(DatatableComponent) myFilterTable: DatatableComponent;

  // ngOnInit() {
  //   this.fetch(data => {
  //     // cache our list
  //     this.temp = [...data];

  //     // push our inital complete list
  //     this.rows = data;
  //   });
  // }

  // fetch(cb) {
  //   const req = new XMLHttpRequest();
  //   req.open('GET', `http://swimlane.github.io/ngx-datatable/assets/data/company.json`);

  //   req.onload = () => {
  //     const data = JSON.parse(req.response);
  //     cb(data);
  //   };

  //   req.send();
  // }

  // updateFilter(event) {
  //   const val = event.target.value.toLowerCase();

  //   // filter our data
  //   const temp = this.temp.filter(function (d) {
  //     return d.name.toLowerCase().indexOf(val) !== -1 || !val;
  //   });

  //   // update the rows
  //   this.rows = temp;
  //   // Whenever the filter changes, always go back to the first page
  //   this.myFilterTable.offset = 0;
  // }
}
